import { Theme } from '@cibo/ui'
export { Theme }

export * from './Links'

export const LOCAL_DATA_TTL = 5 * 60 * 1000
export const MAX_RETRIES = 3
